<template>
    <div class="backend-links">
        <a href="/dealshare">Deal Share</a>
        <a href="/deal-search">Deal Search</a>
        <a href="/aitrain">AI Train</a>
        <a href="/analysis">Analysis</a>
        <a href="/analytics">Analytics</a>
        <a href="/logout">LOG OUT</a>
    </div>
</template>
